/** An unknown metric is `null` on the wire; the table shows an em dash for it, never `0` or `N/A`. */
export const UNKNOWN_METRIC_DASH = "—";

export function formatProductMetric(
  value: number | string | null | undefined,
  format?: string,
): string {
  if (value === null || value === undefined) return UNKNOWN_METRIC_DASH;
  if (typeof value === "string") return value;

  switch (format) {
    case "currency":
      return `$${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    case "currencyNoCents":
      return `$${Math.round(value).toLocaleString()}`;
    case "number":
      return value.toLocaleString();
    case "decimal":
      return value.toFixed(1);
    default:
      return String(value);
  }
}
